module.exports = __webpack_public_path__ + "static/ali-images-7c32814cb16a5e90ad672094b62fb2e6.png";